import stringToInteger from './stringToInteger';
export default stringToInteger;